
import girl from "./assets/girl.png";





export const books = [
  {
    id: 1,
    title: "Blind Papa Reaper Bloom 8.25 Skateboard Deck",
    url: "https://i.ibb.co/58c0RyM/My-project.png" ,
    url2: "https://i.ibb.co/1L8CBzF/Blind-Papa-Reaper-Bloom-8-25-Skateboard-Deck-178200-front-CA-removebg-preview.png",
    originalPrice: 110.95,
    salePrice: 70.95,
    rating: 5,
    description:
      "From Blind and professional skateboarder, Micky Papa, comes the Reaper Bloom 8.25 skateboard deck. This deck features a white bottom ply with graphics of three flowers",
    description2:
      " all with the Blind Reaper mascot's head as the center of the flowers' plus, Papa's name and the Blind logo at the center.",
  },
  {
    id: 2,
    title: "Girl x Sanrio Carroll Kawaii Arcade 8.0 Skateboard Deck",

    url: "https://i.ibb.co/t4bSHmw/Girl-x-Sanrio-Carroll-Kawaii-Arcade-8-0-Skateboard-Deck-366961-front-US-removebg-preview-1.png",
    url2: "https://i.ibb.co/YPD6cKR/Girl-x-Sanrio-Carroll-Kawaii-Arcade-8-0-Skateboard-Deck-366961-back-US-removebg-preview.png",
    originalPrice: 89.99,
    salePrice: null,
    rating: 4.5,
    description:
      "Girl Skateboards and Sanrio team up for the Carroll Kawaii Arcade skateboard deck, measuring 8.0 wide. The signature Mike Carroll pro model features an image of Hello Kitty on the bottom ply, with retro video game style graphics",
    description2:
      "throughout. With a classic popsicle shape and a medium concave, the collaborative Hello Kitty skateboard deck is finished with Girl branding on the top ply.",
  },
  {
    id: 3,
    title: "Santa Cruz Screaming Hand 8.25 Skateboard Deck",
    url: "https://i.ibb.co/THsKHhS/Santa-Cruz-Screaming-Hand-8-25-Skateboard-Deck-334661-back-US-removebg-preview.png",
    url2: "https://i.ibb.co/mtpYpjD/Santa-Cruz-Screaming-Hand-8-25-Skateboard-Deck-334661-front-US-removebg-preview-1.png",
    originalPrice: 64.99,
    salePrice: null,
    rating: 5,
    description:
      "Bring back your big ollies with the Santa Cruz Screaming Hand 8.25 skateboard deck. A classic Screaming Hand logo on the bottom represents some seriously",
    description2:
      "OG skateboard flair, while the moderate pitched kick tails add powerful ollies too.",
  },
  {
    id: 4,
    title: "Santa Cruz McCoy Transcend VX 8.25 Skateboard Deck",
    url: "https://i.ibb.co/8zzBDQp/Santa-Cruz-Mc-Coy-Transcend-VX-8-25-Skateboard-Deck-343137-back-US-removebg-preview.png",
    url2: "https://i.ibb.co/8jkrhyp/Santa-Cruz-Mc-Coy-Transcend-VX-8-25-Skateboard-Deck-343137-front-US-removebg-preview.png",
    originalPrice: 55,
    salePrice: 30,
    rating: 3.5,
    description:
      "Add some durable, striking steez to your skateboard collection with the McCoy Transcend VX 8.25 skateboard deck from Santa Cruz! A wireframe figure appears across the bottom of this deck, being sucked into the void below",
    description2:
      " The VX construction of this deck ensures a light, nimble construction that is durable as can be, making this eye-catching deck a strong choice for any collection.",
  },
  {
    id: 5,
    title: "Anti-Hero x Grimple Stix On Vacation 8.38 Skateboard Deck",
    url: "https://i.ibb.co/JtFN0Dy/Anti-Hero-x-Grimple-Stix-On-Vacation-8-38-Skateboard-Deck-361009-back-US-removebg-preview.png",
    url2: "https://i.ibb.co/6trGmsK/Anti-Hero-x-Grimple-Stix-On-Vacation-8-38-Skateboard-Deck-361009-front-US-removebg-preview.png",
    originalPrice: 64.99,
    salePrice: null,
    rating: 5,
    description:
      "The On Vacation skateboard deck from the Grimple Stix Anti-Hero collection features an 8.38 by 32.25 construction with a bottom ply graphic of Grimple",
    description2:
      "Stix bathing inside of a personfied wood monster, along with flowers, mushrooms, and other foliage for a whimsical look.",
  },
  {
    id: 6,
    title: "Primitive Neal Dirty P Viber 8.25 Skateboard Deck",
    url: "https://i.ibb.co/vz3F0Qd/Primitive-Neal-Dirty-P-Viber-8-25-Skateboard-Deck-362721-back-US-removebg-preview.png",
    url2: "https://i.ibb.co/KxWKjjS/Primitive-Neal-Dirty-P-Viber-8-25-Skateboard-Deck-362721-front-US-removebg-preview.png",
    originalPrice: 110,
    salePrice: 50.5,
    rating: 4,
    description:
      "From Primitive comes the Dirty P Viper skateboard deck, measuring at 8.25 wide and 31.95 long. On the bottom ply of the board is the recognizable Dirty",
    description2:
      "P with a viper set next to it in accents of blue and green. A snake skin pattern can be seen throughout the bottom ply to complete the look.",
  },
  {
    id: 7,
    title: "Primitive x Marvel Silvas Deadpool 8.125 Skateboard Deck",
    url: "https://i.ibb.co/XWZkqgy/Primitive-x-Marvel-Silvas-Deadpool-8-125-Skateboard-Deck-365224-back-US-removebg-preview.png",
    url2: "https://i.ibb.co/M9dwmk3/Primitive-x-Marvel-Silvas-Deadpool-8-125-Skateboard-Deck-365224-front-US-removebg-preview.png",
    originalPrice: 100,
    salePrice: 50,
    rating: 5,
    description:
      "Primitive x Marvel assemble to bring the Silvas Deadpool skateboard, measuring a width of 8.125 wide and a length of 31.75. The bottom ply of the Mason Silvas",
    description2:
      "pro model is adorned with a reflective golden background, showing off a detailed graphic of the well known merc with a mouth, Deadpool, being ripped apart to reveal his skeleton and guts beneath his skin.",
  },
  {
    id: 8,
    title: "HUF x Spider-Man Darkslide 8.25 Skateboard Deck",
    url: "https://i.ibb.co/MSx1f2H/HUF-x-Spider-Man-Darkslide-8-25-Skateboard-Deck-365196-back-US-removebg-preview.png",
    url2: "https://i.ibb.co/h96XBXL/HUF-x-Spider-Man-Darkslide-8-25-Skateboard-Deck-365196-front-US-removebg-preview.png",
    originalPrice: 80,
    salePrice: 50.95,
    rating: 4.5,
    description:
      "HUF x Spider-Man swing into action to bring the Darkslide skateboard deck, measuring a width of 8.25 and a length of 31.875. On the bottom ply of the",
    description2:
      "board is a panel out of a classic Spider-Man comic showing off Peter Parker as he dons the infamous black symbiote suit.",
  },
  {
    id: 9,
    title: "Element x Star Wars Millennium Falcon 8.0 Skateboard Deck",
    url: "https://i.ibb.co/Jq6ypQ5/Element-x-Star-Wars-Millennium-Falcon-8-0-Skateboard-Deck-353471-back-US-removebg-preview.png",
    url2: "https://i.ibb.co/6BQ1dDv/Element-x-Star-Wars-Millennium-Falcon-8-0-Skateboard-Deck-353471-front-US-removebg-preview.png",
    originalPrice: 60,
    salePrice: 30.95,
    rating: 4.5,
    description:
      "This Element x Star Wars skateboard deck measures at 8.0 wide by 31.753 long, and has a graphic of the Millennium Falcon on the bottom ply",
    description2: null,
  },
  {
    id: 10,
    title: "Eh-Ok Block Party 8.5 Skateboard Deck",
    url: "https://i.ibb.co/5nbKFvq/Eh-Ok-Block-Party-8-5-Skateboard-Deck-340453-back-US-removebg-preview.png",
    url2: "https://i.ibb.co/wcgVH7b/Eh-Ok-Block-Party-8-5-Skateboard-Deck-340453-front-US-removebg-preview.png",
    originalPrice: 44.99,
    salePrice: null,
    rating: 5,
    description:
      "The gang's all here, and in style, too! The Block Party 8.5 skateboard deck from Eh-Ok features a ton of characters all throughout the bottom graphic, including a",
    description2:
      "smiling bomb, a sleeping dog, and a man being ejected out of a whale's blowhole, among others. With an 8.5 width, this striking deck belongs in any skate collection or any collection of contemporary art as well.",
  },
  {
    id: 11,
    title: "Monet Babyworld 8.25 Skateboard Deck",
    url: "https://i.ibb.co/FXfhqdw/Monet-Babyworld-8-25-Skateboard-Deck-358332-back-US-removebg-preview.png",
    url2: "https://i.ibb.co/68WwnC0/Monet-Babyworld-8-25-Skateboard-Deck-358332-front-US-removebg-preview.png",
    originalPrice: 55,
    salePrice: 40,
    rating: 5,
    description:
      "The Babyworld Monet skateboard deck comes in an 8.25 by 31.25 construction with a bottom ply graphic of the brand name and two angels surrounding the",
    description2:
      "Earth, all over a grape colorway. This deck has a 7-ply maple fabrication with moderate concave for a versatile and beginner-friendly skateboard.",
  },
  {
    id: 12,
    title: "DGK Boo Disciples 8.25 Skateboard Deck",
    url: "https://i.ibb.co/zGZYczN/DGK-Boo-Disciples-8-25-Skateboard-Deck-342693-back-US-removebg-preview.png",
    url2: "https://i.ibb.co/py2tprn/DGK-Boo-Disciples-8-25-Skateboard-Deck-172294-front-CA-removebg-preview.png",
    originalPrice: 99.99,
    salePrice: 50.95,
    rating: 4.5,
    description:
      "All hail the mighty Saint Boo, with the DGK Boo Disciples 8.25 skateboard deck.",
    description2:
      "A graphic of a woman holding a pot leaf offers a fun representation of Boo's ideal saint, while the moderate pitched kicktails with a wider nose provide pronounces catches for a smooth and buttery ride.",
  },
];
